import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ChildViewModel, AuthService, MembershipOptionQuery, MembershipOption } from '@fgb/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'fgb-child-panel',
  templateUrl: 'child-panel.component.html',
  styleUrls: ['child-panel.component.scss'],
})
export class ChildPanelComponent implements OnInit, OnDestroy {
  membershipOption: MembershipOption[];
  loyaltyPointsCard$: Observable<number | undefined>;
  subscription: Subscription;

  constructor(
    private authService: AuthService,
    private membershipOptionQuery: MembershipOptionQuery
  ) {}

  @Input() child: ChildViewModel;

  ngOnInit() {
    this.subscription = this.membershipOptionQuery.selectAll().subscribe((options) => {
      this.membershipOption = options as MembershipOption[];
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  loginToChild() {
    this.authService.switchUser(this.child.MemberId).toPromise();
  }
}
